import TranslateIcon from '@mui/icons-material/Translate';
import { IconButton, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { authApi } from '@/auth/authApi';
import { useAuthStore } from '@/auth/authStore';
import { SUPPORTED_LANGUAGES, toLanguage } from '@/i18n';

/** Switches UI language; when logged in the choice is also stored on the user (BE uses it for exports/e-mails). */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');
  const authenticated = useAuthStore((s) => s.status === 'authenticated');
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const current = toLanguage(i18n.language);

  const change = (lng: string) => {
    setAnchor(null);
    void i18n.changeLanguage(lng);
    if (authenticated) {
      useAuthStore.setState((s) => (s.user ? { user: { ...s.user, locale: lng } } : s));
      void authApi.updateLocale(lng).catch(() => undefined);
    }
  };

  return (
    <>
      <Tooltip title={t('language.label')}>
        <IconButton color="inherit" onClick={(e) => setAnchor(e.currentTarget)} aria-label={t('language.label')}>
          <TranslateIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {SUPPORTED_LANGUAGES.map((lng) => (
          <MenuItem key={lng} selected={lng === current} onClick={() => change(lng)}>
            <ListItemText primary={t(`language.${lng}`)} secondary={lng.toUpperCase()} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
